import { create } from "zustand";
import { CurrentActiveUserInterface } from "../constants/User";
import { axiosPublic } from "../utils/AxiosInstance";
import { useGetUserLoginStore } from "./useGetUserLoginStore";
import { getAxiosInstance } from "../utils/helperFunction";

interface UserHeaderInterface {
  notificationCount: number;
  userHeader: CurrentActiveUserInterface | undefined;
  userNonActive: { [key: string]: CurrentActiveUserInterface };
  fetchNotificationCount: () => Promise<void>;
  fetchUserHeader: (id: string, role: string, force?: boolean) => Promise<void>;
  fetchUserNonActive: (
    id: string,
    role: string,
    force?: boolean
  ) => Promise<CurrentActiveUserInterface>;
  setUserHeader: (user: CurrentActiveUserInterface) => void;
  initializeUserHeader: (id: string, role: string) => void;
}

export const useUserHeader = create<UserHeaderInterface>((set) => {
  let initialized = false;

  return {
    userHeader: undefined,
    userNonActive: {},
    notificationCount: 0,

    fetchNotificationCount: async () => {
      const currentActiveUser = await useGetUserLoginStore
        .getState()
        .getReturnActiveUser();

      try {
        if (currentActiveUser) {
          let pageType = 1;
          if (currentActiveUser?.role === "reseller") {
            pageType = 2;
          } else if (currentActiveUser?.role === "supplier") {
            pageType = 3;
          }

          const axiosInstance = getAxiosInstance(pageType);

          const response = await axiosInstance.get(
            `/v1/${currentActiveUser?.role}/notification-count`
          );

          if (response.data.status === 200) {
            set({ notificationCount: response.data.data });
          }
        }
      } catch (error: any) {
        console.error("Error fetching notification-count: ", error);
      }
    },
    fetchUserHeader: async (
      id: string,
      role: string,
      force: boolean = false
    ) => {
      const userHeader = useUserHeader.getState().userHeader;

      // kalo ga di force bakal lewat pengecekan ini
      if (!force) {
        // cek jika data sudah ada untuk id dan role yang sama

        if (userHeader?.id === id && userHeader?.role === role) {
          return;
        }
      }

      try {
        const res = await axiosPublic.get(
          `/v1/landing/user-header?id=${id}&role=${role}`
        );

        if (res.data.data) {
          set({ userHeader: res.data.data });
        }
      } catch (err: any) {
        console.error("Error fetching user-header:", err);
      }
    },

    fetchUserNonActive: async (
      id: string,
      role: string,
      force: boolean = false
    ) => {
      const cacheKey = `${id}_${role}`;
      const cache: any = useUserHeader.getState().userNonActive || {};

      try {
        if (!force) {
          if (cache[cacheKey] !== undefined) {
            return cache[cacheKey];
          }
        }

        const res = await axiosPublic.get(
          `/v1/landing/user-header?id=${id}&role=${role}`
        );

        set((state) => ({
          userNonActive: { ...state.userNonActive, [cacheKey]: res.data.data },
        }));
        return res.data.data;
      } catch (error) {
        console.error("Error fetching non-active user:", error);
      }
    },

    setUserHeader: (user: CurrentActiveUserInterface) => {
      set({
        userHeader: user,
      });
    },

    initializeUserHeader: (id: string, role: string) => {
      if (!initialized) {
        initialized = true;
        const store = useUserHeader.getState();
        store.fetchUserHeader(id, role);
      }
    },
  };
});
